export default __webpack_public_path__ + "static/media/HankenGrotesk-Regular.b6ac11a4.ttf";